import React, { useContext } from 'react';
import { shape } from 'prop-types';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { AppContext, Generic4xx } from '@thd-nucleus/app-render';
import { Error } from './pages';
import { getRoutes } from './routes';
import './styles/app.scss';

export const App = ({ serverPages = {} }) => {
  const { instance } = useContext(AppContext);
  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;

  const routes = getRoutes(currentRouteName, currentRouteComponent, serverPages);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route
          path={routes.bundleReviews.path}
          element={<routes.bundleReviews.component />}
        />
        <Route
          path={routes.productReviews.path}
          element={<routes.productReviews.component />}
        />
        <Route
          path={routes.productQuestions.path}
          element={<routes.productQuestions.component />}
        />
        <Route
          path={routes.bundleQuestions.path}
          element={<routes.bundleQuestions.component />}
        />
        <Route
          path={routes.home.path}
          element={<routes.home.component />}
        />
        <Route
          path={routes.thankYou.path}
          element={<routes.thankYou.component />}
        />
        <Route
          path="/error"
          element={<Error />}
        />
        <Route path="/*" element={<Generic4xx />} />
      </Routes>
    </>
  );
};

App.propTypes = {
  serverPages: shape({})
};
